import { httpInterceptor } from '../http-interceptor';

export class MachineService {
  static ENDPOINTS = {
    GET_ALL: 'Machine/getall',
    UPLOAD_DOCUMENT: 'machine/upload',
    ADD_CUSTOMER: 'Machine/savemachine',
    PRINT_ASSET: 'Machine/printasset'
  };

  static async getAllMachines(data) {
    return httpInterceptor.post(this.ENDPOINTS.GET_ALL, data);
  }

  static async createMachine(data) {
    return httpInterceptor.post(this.ENDPOINTS.ADD_CUSTOMER, data);
  }

  static async uploadDocument(documentData) {
    return httpInterceptor.postfile(this.ENDPOINTS.UPLOAD_DOCUMENT, documentData);
  }

  static async printAsset(assetId, cellNumber, printerId) {
    return httpInterceptor.post(this.ENDPOINTS.PRINT_ASSET, {
      AssetId: assetId,
      CellNumber: cellNumber,
      PrinterId: printerId
    });
  }
}
